import { render, staticRenderFns } from "./DailyOrderDetail.vue?vue&type=template&id=74bdcd4e"
import script from "./DailyOrderDetail.vue?vue&type=script&lang=js"
export * from "./DailyOrderDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports